import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57311fd3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=57311fd3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57311fd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57311fd3')) {
      api.createRecord('57311fd3', component.options)
    } else {
      api.reload('57311fd3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57311fd3&scoped=true", function () {
      api.rerender('57311fd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/extra/VabUpload/index.vue"
export default component.exports